import { CorrespondenceRequestCategoryDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CorrespondenceRequestCategoryService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getCorrespondenceRequestCategory(): Observable<
    CorrespondenceRequestCategoryDto[]
  > {
    return this.http.get<CorrespondenceRequestCategoryDto[]>(
      this.url + 'correspondence-request-category'
    );
  }

  createCorrespondenceRequestCategory(
    data: CorrespondenceRequestCategoryDto[]
  ): Observable<CorrespondenceRequestCategoryDto[]> {
    return this.http.post<CorrespondenceRequestCategoryDto[]>(
      this.url + 'correspondence-request-category',
      data
    );
  }
  getSingleCorrespondenceRequestCategory(id: string): Observable<any> {
    return this.http.get(this.url + 'correspondence-request-category/' + id);
  }

  updateCorrespondenceRequestCategory(
    data: CorrespondenceRequestCategoryDto[]
  ): Observable<CorrespondenceRequestCategoryDto[]> {
    return this.http.post<CorrespondenceRequestCategoryDto[]>(
      this.url + 'correspondence-request-category/update',
      data
    );
  }

  deleteCorrespondenceRequestCategory(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('correspondence-request-category', ids.join(', '));
    return this.http.delete(
      this.url + 'correspondence-request-category',
      httpOptions
    );
  }
}
